import { Immutable } from "immer";
import React from "react";

import type { SealyFinanceOptionsBlock as Value } from "@reactivated";

import { EditorContent } from "@thelabnyc/thelabui/src/components/EditorContent";

import headerStyles from "../../styles/composable/finance-page-header.module.scss";
import styles from "./index.module.scss";

type Props = Immutable<{
    value: Value;
}>;

export const SealyFinanceOptionsBlock = (props: Props): React.JSX.Element => {
    const v = props.value;
    // Faithful port of the legacy `finance_page.html` page-loop markup:
    //   <h3 class="finance-page__header">{{ block.value.title }}</h3>
    //   <div class="finance-table__table">{{ block.value.html }}</div>
    // `title` is a CharBlock (plain text); `html` is a RawHTMLBlock whose value
    // already arrives wrapped in <div class="raw-html-block"> from the server, so
    // we render it raw (do NOT strip the wrapper) to match the original output.
    return (
        <>
            <h3 className={headerStyles.financePageHeader}>{v.title}</h3>
            <EditorContent>
                {(marker) => (
                    <div
                        className={styles.financeTableTable}
                        dangerouslySetInnerHTML={{ __html: v.html ?? "" }}
                        {...marker}
                    />
                )}
            </EditorContent>
        </>
    );
};
